export default {
  namespaced: true,
  state() {
    return {
      errors: {},
      inputs: [],
      origin: {},
      data: {},
      touched: false,
      submitting: false,
      awaitAsync: false,
      valid: false
    };
  },
  actions: {},
  getters: {
    DATA: _state => _state.data,
    ERRORS: state => state.errors || {},
    VALID: state => state.touched ? state.valid : true,
    CAN_SUBMIT: state => (!state.touched || (state.valid && !state.submitting && !state.awaitAsync))
  },
  mutations: {
    CREATE_FORM(state, { inputs, data }) {
      Object.assign(state, {
        inputs: inputs || [],
        origin: data || {},
        data: { ...data, ...state.data },
      });
    },

    CLEAR_FORM(state) {
      Object.assign(state, {
        errors: {},
        data: {},
        touched: false,
        submitting: false,
        awaitAsync: false,
        valid: false
      });
    },

    RESET_FORM(state) {
      state.data = state.origin;
    },

    UPDATE(state, fieldObj) {
      state.data = { ...state.data, ...fieldObj };
    },

    REMOVE(state, field) {
      delete state.form[field];
    },
  }
};
